import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { toastr } from "react-redux-toastr";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  form,
  Form as AppForm,
  FormInput,
  TextArea
} from "MODULES/shared/components/Forms";
import { Icon } from "MODULES/shared/components";
import api from "APP_ROOT/api";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

const FORM_NAME = "sendCustomerRmaForm";

export const submitButton = (
  <span>
    <Icon name="envelope" />
    {" Yes, Send RMA"}
  </span>
);

export function Form({ close, handleSubmit, modal }) {
  return (
    <AppForm
      handleSubmit={handleSubmit}
      modal={modal}
      close={close}
      buttonText={submitButton}
    >
      <AppForm.Body>
        <Field component={FormInput} name="to" label="To:" required />
        <Field component={FormInput} name="cc" label="CC:" />
        <Field component={FormInput} name="bcc" label="BCC:" />
        <Field component={FormInput} name="subject" label="Subject" required />
        <Field component={TextArea} name="body" label="Body" required />
        <Field
          component={FormInput}
          name="type"
          type="hidden"
          style={{ height: 0 }}
        />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  close: T.func.isRequired,
  handleSubmit: T.func.isRequired,
  modal: T.bool
};

export default connect((state, props) => ({
  initialValues: {
    body: `Please find attached ${props.rma.company
      .name}'s Return Material Authorization #${props.rma
      .code}.\n\nPlease confirm receipt of this RMA.  Please provide an Airway Bill No. when available.\n\nPLEASE DO NOT INSURE.\n\nThank you for putting trust in ${props
      .currentUser.tenant.name}.
      `,
    cc: props.rma.contact.email,
    subject: `${props.rma.company.name} ${props.rma.code}`,
    type: props.type
  }
}))(
  form({
    form: FORM_NAME,
    validate: values =>
      validator(values, f => {
        f.validate("body", "to").satisfies(rules.required);
        f.validate("to", "cc", "bcc").satisfies(rules.isValidEmail);
      }),
    onSubmit: async (data, _ev, props) => {
      await api.customerRmas
        .send(props.rma.id, data)
        .then(() => {
          props.close();
          toastr.success("Success", "Documents successfully sent.");
        })
        .catch(() =>
          toastr.error(
            "Error",
            "Could not send documents. Please refresh page and try again."
          )
        );
    }
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/CustomerRmas/components/Detail/Actions/Send/Form.jsx